import { MySsPagination } from '~/types/MySsPagination';

export const PAGINATION: MySsPagination = {
  firstItem: 1,
  currentPage: 1,
  pageSize: 20,
  pageCount: 20,
  resultCount: 20,
};

export const ICONS = {
  ADD: 'material-symbols-light:add-circle-outline-rounded',
  ADD_USER: 'material-symbols-light:person-add-outline-rounded',
  BILL: 'material-symbols-light:barcode-scanner-rounded',
  BACKSPACE: 'material-symbols-light:backspace-outline-rounded',
  CALENDAR: 'material-symbols-light:calendar-month-outline-rounded',
  CHART_FILE: 'material-symbols-light:insert-chart-outline-rounded',
  CHECK: 'material-symbols-light:check-rounded',
  CLEAR: 'material-symbols-light:backspace-outline-rounded',
  CLOSE: 'material-symbols-light:close-rounded',
  COMMISSIONS: 'material-symbols-light:currency-exchange-rounded',
  DASHBOARD: 'material-symbols-light:dashboard-outline-rounded',
  DOWNLOAD: 'material-symbols-light:download-rounded',
  CONTACT: 'material-symbols-light:chat-outline-rounded',
  ECONOMIC_GROUP: 'material-symbols-light:domain-add-rounded',
  EDIT: 'material-symbols-light:edit-outline-rounded',
  EXTRACT: 'material-symbols-light:list-alt-outline-rounded',
  FIELD_MENU__CLOSE: 'material-symbols-light:keyboard-arrow-up-rounded',
  FIELD_MENU__OPEN: 'material-symbols-light:keyboard-arrow-down-rounded',
  ARROW_RIGHT: 'material-symbols-light:chevron-right',
  FILTER_LIST: 'material-symbols-light:filter-list-rounded',
  FILTER: 'material-symbols-light:filter-alt-outline',
  FORWARD: 'material-symbols-light:chevron-right-rounded',
  DOWN: 'material-symbols-light:keyboard-arrow-down-rounded',
  HELP: 'material-symbols-light:support-agent-rounded',
  INVOICE: 'material-symbols-light:receipt-long-outline-rounded',
  INFO: 'material-symbols-light:info-outline-rounded',
  ITEMS: 'material-symbols-light:category-outline-rounded',
  MENU: 'material-symbols-light:menu-rounded',
  MORE: 'material-symbols-light:more-horiz',
  OPTIONS: 'material-symbols-light:tv-options-edit-channels-rounded',
  ORDERS: 'material-symbols-light:shopping-bag-outline',
  PLUS: 'material-symbols-light:add-rounded',
  CLOUD_STATEMENT: 'material-symbols-light:sim-card-download-outline-rounded',
  PRINTER: 'material-symbols-light:download-rounded',
  SEND_MESSAGE: 'material-symbols-light:outgoing-mail-outline-rounded',
  SEARCH: 'material-symbols-light:search-rounded',
  SETTINGS: 'material-symbols-light:tune-rounded',
  STATUS: 'material-symbols-light:check-circle-outline-rounded',
  UPLOAD: 'material-symbols-light:upload-rounded',
  USERS: 'material-symbols-light:groups-outline-rounded',
  SHOW: 'material-symbols-light:visibility-outline-rounded',
  HIDE: 'material-symbols-light:visibility-off-outline-rounded',
  ENTER: 'material-symbols-light:jump-to-element-rounded',
  BACK: 'material-symbols-light:arrow-left-alt-rounded',
  SHOPPING_CART: 'material-symbols-light:shopping-cart-outline-rounded',
  GO_TO: 'material-symbols-light:arrow-circle-right-outline-rounded',
  MY_ACCOUNTS: 'material-symbols-light:account-balance-outline-rounded',
  PAID_MONEY: 'material-symbols-light:paid-outline-rounded',
  HELP_QUESTION: 'material-symbols-light:help-outline-rounded',
  PDF: 'material-symbols-light:picture-as-pdf-outline',
  ORDER: 'material-symbols-light:expand-all',
  ORDER_UP: 'material-symbols-light:keyboard-arrow-up-rounded',
  ORDER_DOWN: 'material-symbols-light:keyboard-arrow-down-rounded',
  REQUEST_QUOTE: 'material-symbols-light:request-quote-outline',
  LOCAL_SHIPPING: 'material-symbols-light:local-shipping-outline',
  BOX: 'material-symbols-light:inventory-2-outline',
  PAYMENTS: 'material-symbols-light:payments-outline',
  CREDIT_CARD: 'material-symbols-light:credit-score-outline',
  CLOUD_UPLOAD: 'material-symbols-light:backup-outline',
  ARROW_FORWARD: 'material-symbols-light:arrow-forward',
  ARROW_BACK: 'material-symbols-light:arrow-back',
  EMPTY: 'material-symbols-light:screen-search-desktop-outline',
  LOADING: 'svg-spinners:pulse-rings-multiple',
  WARNING: 'material-symbols-light:warning-outline',
  LOADING_2: 'svg-spinners:180-ring',
};

export const SYSTEM_NAME = 'MyScanSource';
